import { injectable, inject } from 'inversify';
import DITypes from '../DI/types';
import type { IAdapterCache, IAdapterFactory } from '../DI/interfaces';
import JsonRpcDispatcher from '@dealroadshow/json-rpc-dispatcher';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { dataroomUrl } from '@dataroom/url';

@injectable()
class AdapterCache implements IAdapterCache {
  private adapters = new Map<DataroomTenant, JsonRpcDispatcher['adapter']>();

  constructor(
    @inject(DITypes.AdapterFactory) private readonly adapterFactory: IAdapterFactory,
  ) {}

  public get(tenant: DataroomTenant): JsonRpcDispatcher['adapter'] {
    if (!this.adapters.has(tenant)) {
      const adapter = this.adapterFactory.create(
        dataroomUrl(tenant).getRpcUrl(),
        { otelPropagation: true },
      );
      this.adapters.set(tenant, adapter);
    }

    return this.adapters.get(tenant);
  }
}

export default AdapterCache;
